import "./OAuthPage.scss";
import React, {useEffect, useState} from "react";
import {Button} from "antd";
import {useNavigate} from "react-router-dom";
import {LogRegLogo} from "./util/LogRegLogo";
import DashboardApi from "../api/DashboardApi";
import {Spinner} from "./account/misc/Spinner";
import {env} from "../env/env";
import useQueryString from "../hooks/useQueryString";

export default function OAuthPage() {
  const navigate = useNavigate();
  const [logged, setLogged] = useState(false);
  const [loading, setLoading] = useState(false);
  const [prop] = useQueryString<string>("prop");
  const [dashUri] = useQueryString<string>("dash-uri");

  useEffect(() => {
    setLoading(true);
    DashboardApi.status().then((resp) => {
      setLogged(resp.data.member?.logged ?? false);
      setLoading(false);
    }).catch(() => {
      setLoading(false);
    });
  }, []);

  function onLogin() {
    const next = `/account/oauth${encodeURIComponent(`?prop=${prop}&dash-uri=${encodeURIComponent(dashUri)}`)}`;
    navigate(`/account/login?next=${next}`);
  }

  function onCancel() {
    navigate(env.dashboardPath);
  }

  function onAllow() {
    setLoading(true);
    DashboardApi.getOAuthToken().then(resp => {
      const tkn = resp.data;
      const url = `${dashUri}/#${prop}=${encodeURIComponent(tkn)}`;
      console.log(url);
      window.location.href = url;
    });
  }

  return (
    <div className={"oauth-page land-page"}>
      <div className="cvr"/>
      <div className={"step-login step"}>
        <LogRegLogo/>
        {loading && <Spinner/>}
        {!loading && <>
          <h2>Raydiant requires access to read your designs</h2>

          <div className={"form"}>
            {!logged && <Button size={"large"} className={"primary"} onClick={onLogin}>Log In</Button>}
            {logged && <Button size={"large"} className={"primary"} onClick={onAllow}>Allow Raydiant to access my designs</Button>}
            {logged && <Button size={"large"} className={"primary-two"} onClick={onCancel}>Not now</Button>}
          </div>
        </>}
      </div>
    </div>
  );
}
